<template lang="pug">
v-row
  v-col(cols="12")
    template(v-if="!cards.length")
      .text-center(v-if="!readonly")
        v-btn(large color="primary" @click="add" outlined).mx-auto Добавить документ
    template(v-else)
      template(v-for="(card, idx) in cards" )
        v-hover(v-slot="{ hover }")
          v-card.sdo-card.py-4.card-hover.overflow-visible(
            :key="idx"
            flat link
            color="secondary lighten-4"
            target="_blank"
            outlined
            @click="open(card.document.url)"
            :hover="hover"
          )
            v-list-item
              v-list-item-avatar.d-none.d-sm-flex.align-self-start(size="60")
                v-icon(class="secondary" dark large) {{getIcon(card.document.file_name)}}
              v-list-item-content
                p.mt-2.subtitle-1.secondary--text: strong {{ card.title }}
            template(v-if="!readonly")
              v-btn(
                v-if="hover"
                color="secondary"
                fab
                depressed
                small
                style="position: absolute; left: 50%; top: -20px"
                @click.stop="add(idx)"
              )
                h1.font-weight-bold +
              v-btn(
                v-if="hover"
                color="secondary"
                fab
                depressed
                small
                style="position: absolute; left: 50%; bottom: -20px"
                @click.stop="add(idx + 1)"
              )
                h1.font-weight-bold +
              v-btn.btn-remove(
                v-if="hover"
                color="error darken-1"
                depressed
                small
                fab
                style="position: absolute; right: -18px; bottom: -20px;"
                @click.stop="remove(idx)"
              )
                v-icon mdi-delete

</template>
<script>
import ConstructorCard from '@/models/list/ConstructorCard';
import CAddDocument from './CAddDocument.vue';
import { CARD_TYPES } from './constants';

export default {
  components: {
  },
  props: {
    // Array of Cards
    cardsValues: { type: Array, default: null },
    readonly: { type: Boolean, default: false },
  },

  data() {
    return {

    };
  },
  computed: {
    cards: {
      get() {
        return this.cardsValues;
      },
      set(value) {
        this.$emit('update:cards', value);
      },
    },
    mappedCards() {
      return this.cards.map((card) => ({
        name: card.title,
        link: card.url,
      }));
    },
  },
  methods: {
    open(url) {
      window.open(url);
    },
    getIcon(fileName) {
      const IMAGE_TYPES = ['jpg', 'png', 'svg'];
      const isImage = IMAGE_TYPES.includes(fileName.split('.')[1]);
      return isImage ? 'mdi-image' : 'mdi-file-document-outline';
    },
    add(positionIdx) {
      this.$modals.show('generic-controller', {
        title: 'Добавить видео',
        component: CAddDocument,
        'component-props': {
          type: CARD_TYPES.document,
          success: (link) => {
            this.cards.splice(positionIdx, 0, new ConstructorCard(link));
            this.$modals.close();
          },
        },
      });
    },
    remove(positionIdx) {
      const cards = [...this.cardsValues];
      cards.splice(positionIdx, 1);
      this.$emit('update:cards', cards);
      this.$modals.close();
    },
  },
};
</script>
<style lang="scss" scoped>
  .btn-remove {
    opacity: .5;
    transition: all .2s;

    &:hover {
      opacity: 1;
    }
  }
  .card-hover {
    cursor: pointer;
    transition: all .2s;

    &:hover {
      transform: scale(1.01);
    }
  }
</style>
